import { makeAutoObservable, runInAction } from 'mobx';
import type { RootStore } from './root-store';
import { CriticalNotificationMobxDto } from '../mobx/dtos/critical-notification/critical-notification-mobx-dto';

export class CriticalNotificationStore {
    rootStore: RootStore;

    lastCriticalNotification: CriticalNotificationMobxDto | null = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this, { rootStore: false });
    }

    async fetchCriticalNotifications(): Promise<void> {
        try {
            const fetchedCriticalNotifications =
                await this.rootStore.apiClient.criticalNotificationController.criticalNotificationControllerGetList();
            runInAction(() => {
                if (fetchedCriticalNotifications.length > 0) {
                    const lastDto = fetchedCriticalNotifications.reduce((latest, current) =>
                        current.createdAt > latest.createdAt ? current : latest,
                    );

                    this.lastCriticalNotification = CriticalNotificationMobxDto.create(lastDto);
                }
            });
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
}
